import _classCallCheck from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Transaction } from "./transaction";
/**
 * Server Transaction.
 * @remarks
 * The server transaction is responsible for the delivery of requests to
 * the TU and the reliable transmission of responses.  It accomplishes
 * this through a state machine.  Server transactions are created by the
 * core when a request is received, and transaction handling is desired
 * for that request (this is not always the case).
 * https://tools.ietf.org/html/rfc3261#section-17.2
 * @public
 */
export var ServerTransaction = /*#__PURE__*/function (_Transaction) {
  _inherits(ServerTransaction, _Transaction);
  var _super = _createSuper(ServerTransaction);
  function ServerTransaction(_request, transport, user, state, loggerCategory) {
    var _this;
    _classCallCheck(this, ServerTransaction);
    _this = _super.call(this, transport, user, _request.viaBranch, state, loggerCategory);
    _this._request = _request;
    _this.user = user;
    return _this;
  }
  /** The incoming request the transaction handling. */
  _createClass(ServerTransaction, [{
    key: "request",
    get: function get() {
      return this._request;
    }
  }]);
  return ServerTransaction;
}(Transaction);